import { type CSSProperties } from "react";

import clsx from "clsx";

import { type ColumnDef } from "@features/landing-page-analytics/types";

interface Cell {
  colSpan: number;
  column: {
    type?: unknown;
    column: ColumnDef;
  };
}

interface Props {
  className?: string;
  style?: CSSProperties;
  isFixed: boolean;
  children: JSX.Element[];
}

export const TableHeadWithFixedRow = ({
  isFixed,
  className,
  style,
  children,
}: Props) => {
  return (
    <thead
      className={clsx(
        {
          "dx-g-bs4-fixed-header dx-g-bs4-table-sticky bg-v2-primary": isFixed,
        },
        className,
      )}
      style={style}
    >
      {children}
    </thead>
  );
};
